module.exports = __webpack_public_path__ + "img/step3.edbb50ca.png";